import React from "react";
import PropTypes from "prop-types";
import Button from "./Button";
import { Link } from "react-router-dom";
import { UserConsumer } from "./Context";
import { useEffect, useState } from "react";
import LanguageOptionDropdown from "./LanguageOptionDropdown";
import { useTranslation } from "react-i18next";
import SessionTimer from "./SessionTimer";

const Header = ({
    logo,
    isWithEmbed,
    aboutButton,
    embedButton,
    instructionButton,
    langSwitcher,
    editMember,
    finishSession,
    color,
    background,
    visibility,
    display,
    onOpenPassword,
    isPlaying,
    sessionRemainingSeconds,
    totalSessionMinutes,
    usePassword,
    login,
    hideActions,
}) => {
    const logo_header = window.welcome.logo_welcome;
    const [isLogin, setLogin] = useState(false);
    const { t } = useTranslation();
    const Login = () => {
        if (usePassword === true && !login) setLogin(true);
    };
    // @ts-ignore
    const languageCodes = window.wpml_language_codes?.language_codes || [];

    useEffect(() => {
        Login();
    });

    return (
        <header
            className={`header ${
                isPlaying ? "is-game-session is-playing" : ""
            }`}
        >
            <div className="header-inner">
                <div className="header-left-side">
                    {logo_header ? (
                        <img
                            className="header-logo"
                            alt="logo"
                            src={logo_header}
                        />
                    ) : (
                        <div />
                    )}
                </div>

                {isPlaying &&
                    (sessionRemainingSeconds !== undefined ||
                        totalSessionMinutes) && (
                        <SessionTimer
                            remainingSeconds={sessionRemainingSeconds}
                            totalMinutes={totalSessionMinutes}
                        />
                    )}

                {!hideActions && (
                    <div className="header-actions">
                        {languageCodes.length > 1 && (
                            <div className="header-action-item">
                                <LanguageOptionDropdown />
                            </div>
                        )}

                        <div className="header-action-item">
                            <Button
                                iconFA="info-circle"
                                iconPosition="start"
                                {...aboutButton}
                                text="Info"
                                title="Info"
                            />
                        </div>

                        <div className="header-action-item">
                            <UserConsumer>
                                {(value) =>
                                    isLogin ? (
                                        <Link
                                            className="change-team-button"
                                            to="/password-page"
                                            state={{ value, setupTeam: true }}
                                        >
                                            <Button
                                                {...editMember}
                                                className="btn-action"
                                                iconFA="users"
                                                iconPosition="start"
                                                color={color}
                                                // background={background}
                                                title={t("Team Page")}
                                                visibility={visibility}
                                            />
                                        </Link>
                                    ) : (
                                        <Link
                                            className="change-team-button"
                                            to="/intro"
                                            state={{ value, setupTeam: true }}
                                        >
                                            <Button
                                                {...editMember}
                                                className="btn-action"
                                                iconFA="users"
                                                iconPosition="start"
                                                color={color}
                                                // background={background}
                                                title={t("Team Page")}
                                                visibility={visibility}
                                            />
                                        </Link>
                                    )
                                }
                            </UserConsumer>
                        </div>

                        <div className="header-action-item">
                            <UserConsumer>
                                {(value) => (
                                    <Link
                                        className="finish-session-button"
                                        to="/end-page"
                                        state={{ value }}
                                    >
                                        <Button
                                            {...finishSession}
                                            className="btn-action"
                                            iconFA="edit"
                                            iconPosition="start"
                                            visibility={visibility}
                                            display={display}
                                            title={t("Finish this Session")}
                                        />
                                    </Link>
                                )}
                            </UserConsumer>
                        </div>
                    </div>
                )}
            </div>
        </header>
    );
};

Header.propTypes = {
    logo: PropTypes.string,
    isWithEmbed: PropTypes.bool,
    aboutButton: PropTypes.shape(Button.propTypes),
    embedButton: PropTypes.shape(Button.propTypes),
};

Header.defaultProps = {
    isWithEmbed: false,
};

export default Header;
